import React, { useEffect } from "react";
import "../../styles/Login.css";
import cgiLogo from "../../assets/images/CGI-Logo.jpg";

const LoginPage: React.FC = () => {
  useEffect(() => {
    const header = document.querySelector("header");
    const footer = document.querySelector("footer");
    if (header) header.style.display = "none";
    if (footer) footer.style.display = "none";
    return () => {
      if (header) header.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);

  const handleMicrosoftLogin = () => {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get("redirect") || "/";
    window.location.href =
      "/.auth/login/aad?post_login_redirect_uri=" +
      encodeURIComponent(window.location.origin + redirect);
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-logo">
          <img src={cgiLogo} alt="CGI Logo" />
          <span>SHORTFY</span>
        </div>
        <h1 className="login-title">
          Short for You — One Place for All Your Links
        </h1>
        <p className="login-subtitle">
          CGI’s way to simplify link sharing and keep everything in one place. Shorten long URLs, brand them for a professional look, and share easily across teams.
        </p>
        <button className="login-button" onClick={handleMicrosoftLogin}>
          Login
        </button>
        <p className="login-help-text">
          Trouble signing in? Please{" "}
          <a href="mailto:AIS.DE@cgi.com">contact us</a>.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
